module.exports = __webpack_public_path__ + "img/voice_record.877e1569.svg";